export default __webpack_public_path__ + "static/media/نموذج طلب التدريب الصيفي.2dbb1cd6.pdf";